import { EMPTY, TModuleKey, TTabsState } from 'store/slices/insightsTabsSlice'
import { RootState } from 'store/store'

export const selectTabs =
  (module: TModuleKey, deliveryId?: string) =>
  (s: RootState): TTabsState =>
    (deliveryId && s.insightsTabs[module]?.[deliveryId]) ?? EMPTY

export const selectIsAnyOpen =
  (module: TModuleKey, deliveryId?: string) =>
  (s: RootState): boolean => {
    const t = selectTabs(module, deliveryId)(s)
    return t.insights || t.recommendations
  }
